const get = require('lodash/get')
const isWarehouseMatch = require('./is-warehouse-match')

module.exports = getShipmentConfirmEligibility

// Plain data in, plain facts out — no role/permission branching, no api
// calls. This computes the shipment-shape/location facts that confirm/pack
// eligibility depends on; the caller is responsible for combining these
// with whatever permission check applies to it (e.g. web's userIsAuthorised).
// Same convention as is-warehouse-match.js, which this wraps.
function getShipmentConfirmEligibility ({ shipment, destinationLocation, userLocation }) {
  const { planningType, status } = shipment
  const isImmediatePurchaseNew = planningType === 'immediate_purchase' && status === 'new'
  // TODO: This is a temporary solution. We should move all validation logic to a single source of truth.
  // I just noticed that we have shipment validation already existing on the web app like here
  // web/src/subapps/shipments/shipments/ShipmentsContainer.js in initializeShipments function,
  // and we also have lots of validation in web/src/common/utils/shipment.js
  // we should unify all in 1 place and use it across the app, but for now we will just add this check here
  const isReturnShipment = status === 'received'

  const isLastMileDelivery = !destinationLocation || destinationLocation.level === 'sdp'
  const isOwnDestination = isWarehouseMatch(get(userLocation, 'id'), get(shipment, 'destination.id'))
  const isOwnOrigin = isWarehouseMatch(get(userLocation, 'id'), get(shipment, 'origin.id'))

  return {
    isImmediatePurchaseNew,
    isReturnShipment,
    isLastMileDelivery,
    isOwnDestination,
    isOwnOrigin
  }
}
